import logger from "../../utils/logger";

export const getOrCreateDeviceId = () => {
    const key = 'c1st_device_id';
    let deviceId = localStorage.getItem(key);
    if (!deviceId) {
        deviceId = crypto.randomUUID();
        localStorage.setItem(key, deviceId);
    }
    return deviceId;
};

export const getSessionUUID = () => {

    const storedData = localStorage.getItem('REACT_TOKEN_AUTH_KEY');
    if (!storedData) {
        logger.warn('No data found in REACT_TOKEN_AUTH_KEY');
        return null;
    }

    try {
        const session = JSON.parse(storedData); // Parse the JSON object
        return session?.session_uuid || null; // Return session_uuid if available
    } catch (error) {
        logger.error('Error parsing REACT_TOKEN_AUTH_KEY:', error);
        return null;
    }
};